import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../ui/navBar/NavBar";
import MfaAdviceDialog from "../ui/MfaAdviceDialog";
import { AxiosInterceptor } from "./AxiosInterceptor";
import { AuthContext } from "./TSAuthProvider";

const AppMainContainer = () => {
  const isIframe = window.self !== window.top;

  return isIframe ? (
    <AxiosInterceptor>
      <Outlet />
    </AxiosInterceptor>
  ) : (
    <NavBar>
      <div style={{ marginTop: "10px", marginLeft: "20px", width: "calc(100% - 30px)" }}>
        <AxiosInterceptor>
          <Outlet />
        </AxiosInterceptor>
      </div>


    </NavBar>
  );
};

export default AppMainContainer;
